<template>
  <div class="teacher-profile-view">
    <header class="teacher-profile-view__header">
      <h1 class="teacher-profile-view__title">Teacher Profile</h1>
    </header>
    <template v-if="teacherProfile">
      <div class="teacher-profile-view__sections">
        <teacher-profile-info
          :teacher-profile="teacherProfile"
          :restricted-section-visible="restrictedSectionVisible()"
        />
      </div>
      <div class="teacher-profile-view__sections">
        <div class="teacher-profile-view__sections-item">
          <teacher-skill-info :teacher-profile="teacherProfile" />
        </div>
        <div class="teacher-profile-view__sections-item">
          <teacher-bio :teacher-profile="teacherProfile" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FEATURES } from '@/constants';

import TeacherProfileInfo from './components/TeacherProfileInfo';
import TeacherSkillInfo from './components/TeacherSkillInfo';
import TeacherBio from './components/TeacherBio';

export default {
  name: 'TeacherProfile',

  components: {
    TeacherProfileInfo,
    TeacherSkillInfo,
    TeacherBio,
  },

  data() {
    return {
      teacherProfile: null,
      routeParams: {
        teacherHashEmail: this.$route.params.teacherHashEmail,
      },
    };
  },

  async created() {
    await this.fetchProfile();
  },

  computed: {
    ...mapGetters('features', ['canUseFeature']),
  },

  methods: {
    ...mapActions('manageTeachers', {
      fetchTeacherProfile: 'FETCH_TEACHER_PROFILE',
    }),

    async fetchProfile() {
      this.teacherProfile = await this.fetchTeacherProfile(this.routeParams.teacherHashEmail);
    },
    restrictedSectionVisible() {
      return this.canUseFeature(FEATURES.MANAGE_TEACHERS_RESTRICTED_SETTINGS);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/mixins';
@import '~styles/tools/variables';

.teacher-profile-view {
  padding-bottom: 20px;

  &__header {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  &__title {
    @include pageTitle;
  }

  &__sections {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;

    &-item {
      width: 50%;
    }
  }
}
</style>
